<template>
  <main class="sa-content ">
    <div v-if="loader">
          <img src="../../../src/assets/img/loader.svg" alt="loader" class="sa-loader sa-loader-top" />
        </div>
    <div v-else class="sa-card-large ">
    <div class="sa-mob-header">
      <h5 class="sa-card-tit">Rate & Review</h5>
      <button class="sa-btn-back sa-h-sm-up" @click="$router.go(-1)">
        <i class="icon-arrow-left"></i>
      </button>
    </div>
    <div v-if="!filterratereview" class="sa-mt20 sa-pb20 sa-mob-cont">
      <div class="sa-card sa-card-noborder">
        <div class="sa-row">
          <rate-progress-bar :progBar="rating" v-if="rating" />
          <rate-bar-chart :rateBar="rating.data.rtg" v-if="rating && rating.data && rating.data.rtg" />
        </div>
      </div>  
          <rate-post v-if="rating && rating.data" :data='rating.data.rvw'></rate-post>
          <div class="sa-see-all" v-if="rating && rating.data && rating.data.rvw && rating.data.rvw.length > 0"  @click="allReviewData()">See all reviews <i class="icon-arrow-right sa-ml5"></i></div>
    </div>
      <div class="sa-mt20 sa-pb20" v-else>
       <button class="sa-btn-back sa-h-xs" @click="filterratereview = false">
        <i class="icon-arrow-left"></i>
      </button>
       <h6 class="sa-card-tit ">Filter</h6>
       <ul class="sa-d-flex">
         <li  @click="reviewdataList(index+1)" v-for="(rate, index) in 5" :key="rate" class="sa-filter-btn" :class="{'active': activeIndex === index}">{{rate}} <i class="icon-star"></i></li>
        </ul>
       <h6 v-if="ratinglist && ratinglist.data" class="sa-card-tit sa-mt15">All reviews</h6>
       <rate-post :data='ratinglist.data'></rate-post>
      </div>
      </div>
  </main>
</template>
<script>
  import VueApexCharts from 'vue-apexcharts'
  import rateandreviewVue from "../../components/rateandreview/RateReviewPost.vue";
  import { pro_url, oh_url } from "../../../config/endpoints";
import RateBarChartVue from '../../components/rateandreview/RateBarChart.vue';
import RateProgressBarVue from '../../components/rateandreview/RateProgressBar.vue';
export default {
    components: {
      apexchart: VueApexCharts,
      "rate-post": rateandreviewVue,
      'rate-bar-chart': RateBarChartVue,
      'rate-progress-bar': RateProgressBarVue
    },
  data() {
    return {
      activeIndex: undefined,
      index:null,
      loader: false,
      rating : {},
      ratinglist: {},
      filterratereview : false,     
    };
  },
  methods: {
    reviewdata(){
      let _self = this
      _self.loader= true
        _self.$store
        .dispatch("httpPost", {
          uri: `${pro_url}/rating`,
        })
        .then(response => {
          _self.loader= false
          if (response && response.status === 1000) {
            _self.rating = response;
          } else {
          }
        })
    },
    allReviewData(){
      this.filterratereview = true
      this.reviewdataList(null)
    },
    reviewdataList(index){
      this.activeIndex = index-1
      let data = {}
      if(index){
        data = {
          rtg : index
        }
      }
      let _self = this
        _self.$store
        .dispatch("httpPost", {
          uri: `${pro_url}/ratinglist`,
          body: data
        })
        .then(response => {
          if (response && response.status === 1000) {
            _self.ratinglist = response;
          } else {
          }
        })
    }
  },
  mounted(){
    this.reviewdata()
    this.reviewdataList()
  }
}
</script>